module.exports = __webpack_public_path__ + "static/media/skin-cancer-news.efe09a37.jpg";